















import { CartItem } from '@/models/cart/cart-item'
import { isDisplayItem } from '@/models/cart/group/group'
import {
  GroupedCartItems,
} from '@spa/components/pages/cart/model/cart/group/group-cart-items'
import Vue, { VueConstructor } from 'vue'
import { Component, Prop } from 'vue-property-decorator'

const noLayout = Vue.extend({
  name: 'NoLayout',
  template:
    '<div class="no-layout">' +
    '<slot></slot>' +
    '</div>',
})

const noGrouping = (items: CartItem[]) => ({ '': items })

@Component
/**
 * カート内商品を、一定の条件にしたがってグルーピングして表示する.
 * グルーピングの条件と、実際に表示する時のレイアウトは可変.
 *
 * @see https://my-color.esa.io/posts/393
 */
export default class CartItemGroupList extends Vue {
  @Prop({ required: true })
  items: CartItem[]

  // 動的にスイッチする必要がでてきたら、Propsにする
  groupBy: (items: CartItem[]) => { [key: string]: CartItem[] } = noGrouping
  layout: VueConstructor = noLayout

  get groups(): GroupedCartItems {
    return this.groupBy(this.items)
  }

  selectOnlyDisplayable(items: CartItem[]): CartItem[] {
    return items.filter(isDisplayItem)
  }
}
